class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.pageThreshold = this.getAttribute('data-pageThreshold') || 2;
    this.anchor = this.querySelector('.nw-button');
  }

  connectedCallback() {
    this.anchor.addEventListener('click', () => {
      localStorage.setItem('nwClosed', true);
    });
    if (localStorage.getItem('visitCount') == null) {
      localStorage.setItem('visitCount', 1);
      localStorage.removeItem('nwClosed');
    } else {
      localStorage.setItem('visitCount', parseInt(localStorage.getItem('visitCount')) + 1);
    }

    if (localStorage.getItem('visitCount') == this.pageThreshold || (localStorage.getItem('nwClosed') == null && localStorage.getItem('visitCount') > this.pageThreshold)) {
      this.show(null, false);
    }
  }

  hide(preventFocus = false) {
    localStorage.setItem('nwClosed', true);
    this.classList.remove('open');
    super.hide();
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
